import React from "react";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { get, includes, map, filter, sortBy, cloneDeep } from "lodash";
import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";

import { fetchGet, fetchPost } from "../../../api/fetch";
import HspSecondaryDialog from "./HspSecondaryDialog";
import HspSurveyDialog from "./HspSurveyDialog";
import HspTemperatureDialog from "./HspTemperatureDialog";
import TableCellStyled from "../../Common/TableCellStyled";
import TagColor from "../../Common/TagColor";
import ProfileDialog from "../../Profiles/ProfileDialog";
import LogDetailsDialog from "../../Profiles/LogDetailsDialog";
import { getLov } from "../../../utils/lov";
import { formatDate } from "../../../utils/date";
import { getLukeActionColor } from "../../../utils/eventGroups";
import { logDetailsPermissions } from "../../../constants/dashboards";
import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const columns = {
  0: [
    {
      name: "site_profileName",
      minWidth: 150,
    },
    {
      name: "profiles_tag",
      minWidth: 150,
    },
    {
      name: "dashboard_questionnaireCount",
      minWidth: 150,
    },
  ],
  1: [
    {
      name: "site_ref",
      minWidth: 100,
      width: 100,
    },
    {
      name: "site_dateTime",
      minWidth: 150,
    },
    {
      name: "site_profileName",
      minWidth: 150,
    },
    {
      name: "profiles_tag",
      minWidth: 150,
    },
    {
      name: "profiles_location",
      minWidth: 150,
    },
    {
      name: "site_site2",
      minWidth: 150,
    },
    {
      name: "site_zone",
      minWidth: 150,
    },
    {
      name: "profiles_verification",
      minWidth: 200,
    },
    {
      name: "luke_action",
      id: 158,
      minWidth: 240,
    },
    {
      minWidth: 60,
      icon: images.temperatureIcon,
      iconName: "dashboard_fever",
    },
    {
      name: "decision",
      id: 105,
      minWidth: 150,
    },
  ],
  2: [
    {
      name: "site_dateTime",
      minWidth: 150,
    },
    {
      name: "site_profileName",
      minWidth: 150,
    },
    {
      name: "profiles_tag",
      minWidth: 150,
    },
    {
      name: "profiles_location",
      minWidth: 150,
    },
    {
      name: "profiles_verification",
      minWidth: 200,
    },
    {
      name: "luke_action",
      id: 158,
      minWidth: 240,
    },
  ],
};

const styles = {
  link: {
    color: colors.primary,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const HspScreeningCoverageDialog = (props) => {
  const { language, open, setOpen, subSection, filters } = props;
  const [data, setData] = React.useState();
  const [lov, setLov] = React.useState();
  const [isFetching, setIsFetching] = React.useState(false);

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filters)]);

  const fetchLov = async () => {
    try {
      setLov({
        tags: await getLov("tags"),
        zones: await fetchGet("zones/search"),
        105: await getLov(105),
        158: await getLov(158),
        eventTypes: await getLov("eventTypes"),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const fetchData = async () => {
    if (
      get(filters, ["header", "section"]) &&
      get(filters, ["header", "subsection"])
    ) {
      setIsFetching(true);
      try {
        let res;
        if (get(filters, ["header", "subsection"]) === "all") {
          let newFilters = cloneDeep(filters);
          newFilters.header.subsection = "total";
          let res1 = await fetchPost("api/v1/es/details", newFilters);
          newFilters.header.subsection = "notcompleted";
          let res2 = await fetchPost("api/v1/es/details", newFilters);
          res = [...res1, ...res2];
        } else if (
          includes(
            ["total", "notcompleted"],
            get(filters, ["header", "subsection"])
          )
        ) {
          res = await fetchPost("api/v1/es/details", filters);
        } else if (
          includes(["remote", "onsite"], get(filters, ["header", "subsection"]))
        ) {
          res = await fetchPost("api/v1/es/details", filters);
        }
        setData(res);
      } catch (e) {
        console.log(e);
      }
      setIsFetching(false);
    }
  };

  const dataFunctions = [];
  if (includes(["remote", "onsite"], subSection)) {
    if (subSection === "onsite") {
      dataFunctions.push((item) => get(item, ["event_group_parent_id"]));
    }
    dataFunctions.push((item) => formatDate(get(item, ["start"])));
    dataFunctions.push((item) => get(item, ["name"]));
    dataFunctions.push((item) =>
      get(
        filter(
          get(lov, ["tags"]),
          (t) => t.id === get(item, ["profile_tag_id"])
        ),
        [0, `name_${language}`]
      )
    );
    dataFunctions.push(() => I18n.get(`dashboard_${subSection}`));
    if (subSection === "onsite") {
      dataFunctions.push((item) =>
        get(
          filter(
            get(lov, ["zones"]),
            (z) => get(z, ["site_id"]) === get(item, ["site_id"])
          ),
          [0, "site_name"]
        )
      );
      dataFunctions.push((item) =>
        get(
          filter(
            get(lov, ["zones"]),
            (z) => get(z, ["zone_id"]) === get(item, ["zone_id"])
          ),
          [0, "zone_name"]
        )
      );
    }
    dataFunctions.push((item) =>
      get(
        filter(
          get(lov, ["eventTypes"]),
          (e) =>
            get(e, ["id"]) ===
            (get(item, ["event_type_id"]) === 91
              ? 81
              : get(item, ["event_type_id"]))
        ),
        [0, `name_${language}`]
      )
    );
    dataFunctions.push((item) =>
      get(
        filter(
          get(lov, [158]),
          (attrValue) => get(attrValue, ["id"]) === get(item, ["lukeaction"])
        ),
        [0, `name_${language}`]
      )
    );
    if (subSection === "onsite") {
      dataFunctions.push((item) =>
        get(item, ["fever"]) === true
          ? I18n.get("profiles_yes")
          : get(item, ["fever"]) === false
            ? I18n.get("profiles_no")
            : ""
      );
      dataFunctions.push((item) =>
        get(
          filter(
            get(lov, [105]),
            (attrValue) => get(attrValue, ["id"]) === get(item, ["decision"])
          ),
          [0, `name_${language}`]
        )
      );
    }
  } else {
    dataFunctions.push((item) => get(item, ["name"]));
    dataFunctions.push((item) =>
      get(
        filter(
          get(lov, ["tags"]),
          (t) => t.id === get(item, ["profile_tag_id"])
        ),
        [0, `name_${language}`]
      )
    );
    dataFunctions.push((item) => get(item, ["count"]));
  }

  const title =
    subSection === "all"
      ? I18n.get("dashboard_screeningCoverage")
      : subSection === "remote"
        ? `${I18n.get("dashboard_totalScreeningCounts")} - ${I18n.get(
          "profiles_online"
        )}`
        : subSection === "onsite"
          ? `${I18n.get("dashboard_totalScreeningCounts")} - ${I18n.get(
            "dashboard_onSite"
          )}`
          : subSection === "total"
            ? `${I18n.get("dashboard_uniqueEmployees")} - ${I18n.get(
              "dashboard_atLeast1Screening"
            )}`
            : subSection === "notcompleted"
              ? `${I18n.get("dashboard_uniqueEmployees")} - ${I18n.get(
                "dashboard_noScreening"
              )}`
              : "";

  return (
    <HspSecondaryDialog
      open={open}
      setOpen={(open) => {
        setOpen({ open });
        setData();
      }}
      title={title}
      fetchData={fetchData}
      columns={get(columns, [
        subSection === "remote" ? 2 : subSection === "onsite" ? 1 : 0,
      ])}
      isFetching={isFetching}
      data={sortBy(data, (item) => -new Date(get(item, ["start"])))}
      dataFunctions={dataFunctions}
    >
      {includes(["remote", "onsite"], subSection)
        ? map(
          sortBy(data, (item) => -new Date(get(item, ["start"]))),
          (item, index) => (
            <TableRow
              key={index}
              style={{
                backgroundColor:
                  index % 2 === 0 ? colors.white : colors.tableDarkBg,
              }}
            >
              {subSection === "onsite" && (
                <TableCellStyled>
                  {get(item, ["event_group_parent_id"]) ? (
                    <LogDetailsDialog
                      logId={get(item, ["event_group_parent_id"])}
                      blockLevel2={true}
                      permissions={logDetailsPermissions}
                    />
                  ) : (
                    <span className="text-54">-</span>
                  )}
                </TableCellStyled>
              )}
              <TableCellStyled className="text-54">
                {formatDate(get(item, ["start"]))}
              </TableCellStyled>
              <TableCellStyled>
                <ProfileDialog
                  profileId={get(item, ["profile_id"])}
                  name={get(item, ["name"])}
                  blockLevel2={true}
                />
              </TableCellStyled>
              <TableCellStyled>
                <TagColor
                  name={get(
                    filter(
                      get(lov, ["tags"]),
                      (t) => t.id === get(item, ["profile_tag_id"])
                    ),
                    [0, `name_${language}`]
                  )}
                  color={get(
                    filter(
                      get(lov, ["tags"]),
                      (t) => t.id === get(item, ["profile_tag_id"])
                    ),
                    [0, "color", "rgb"]
                  )}
                />
              </TableCellStyled>
              <TableCellStyled className="text-54">
                {I18n.get(`dashboard_${subSection}`)}
              </TableCellStyled>
              {subSection === "onsite" && (
                <TableCellStyled className="text-54">
                  {get(
                    filter(
                      get(lov, ["zones"]),
                      (z) => get(z, ["site_id"]) === get(item, ["site_id"])
                    ),
                    [0, "site_name"]
                  )}
                </TableCellStyled>
              )}
              {subSection === "onsite" && (
                <TableCellStyled className="text-54">
                  {get(
                    filter(
                      get(lov, ["zones"]),
                      (z) => get(z, ["zone_id"]) === get(item, ["zone_id"])
                    ),
                    [0, "zone_name"]
                  )}
                </TableCellStyled>
              )}
              <TableCellStyled>
                <HspSurveyDialog item={item} language={language} lov={lov} />
              </TableCellStyled>
              <TableCellStyled>
                {get(
                  filter(
                    get(lov, [158]),
                    (attrValue) =>
                      get(attrValue, ["id"]) === get(item, ["lukeaction"])
                  ),
                  [0, `name_${language}`]
                ) && (
                    <Grid container alignItems="center">
                      <Grid
                        item
                        style={{
                          marginRight: "5px",
                          width: "14px",
                          height: "14px",
                          backgroundColor: getLukeActionColor(
                            JSON.stringify(get(item, ["survey_instructions"]))
                          ),
                          borderRadius: "2px",
                        }}
                      />
                      <Grid item className="text-54">
                        {get(
                          filter(
                            get(lov, [158]),
                            (attrValue) =>
                              get(attrValue, ["id"]) ===
                              get(item, ["lukeaction"])
                          ),
                          [0, `name_${language}`]
                        )}
                      </Grid>
                    </Grid>
                  )}
              </TableCellStyled>
              {subSection === "onsite" && (
                <TableCellStyled>
                  <HspTemperatureDialog item={item} language={language} />
                </TableCellStyled>
              )}
              {subSection === "onsite" && (
                <TableCellStyled className="text-54">
                  {get(
                    filter(
                      get(lov, [105]),
                      (attrValue) =>
                        get(attrValue, ["id"]) === get(item, ["decision"])
                    ),
                    [0, `name_${language}`]
                  )}
                </TableCellStyled>
              )}
            </TableRow>
          )
        )
        : map(data, (item, index) => (
          <TableRow
            key={index}
            style={{
              backgroundColor:
                index % 2 === 0 ? colors.white : colors.tableDarkBg,
            }}
          >
            <TableCellStyled>
              <ProfileDialog
                profileId={get(item, ["id"])}
                name={get(item, ["name"])}
              />
            </TableCellStyled>
            <TableCellStyled>
              <TagColor
                name={get(
                  filter(
                    get(lov, ["tags"]),
                    (t) => t.id === get(item, ["profile_tag_id"])
                  ),
                  [0, `name_${language}`]
                )}
                color={get(
                  filter(
                    get(lov, ["tags"]),
                    (t) => t.id === get(item, ["profile_tag_id"])
                  ),
                  [0, "color", "rgb"]
                )}
              />
            </TableCellStyled>
            <TableCellStyled className="text-54">
              {get(item, ["count"])}
            </TableCellStyled>
          </TableRow>
        ))}
    </HspSecondaryDialog>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(HspScreeningCoverageDialog)
);
